import { render } from "./DailySalesOrders.vue?vue&type=template&id=e708977a"
import script from "./DailySalesOrders.vue?vue&type=script&lang=js"
export * from "./DailySalesOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__